var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "34px",
    viewBox: "0 0 36 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrows") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Dark-Mode",
    transform: "translate(-293.000000, -337.000000)",
    fill: "#71889C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Monthly-Savings",
    transform: "translate(293.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrows",
    transform: "translate(0.105263, 132.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.4,
    opacity: 0.5,
    cx: 17.0941828,
    cy: 17,
    rx: 17.0941828,
    ry: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6696913,9.41879195 C20.0741549,8.86040268 19.1121347,8.86040268 18.5165984,9.41879195 L11.5075941,15.990604 C10.9120577,16.5489933 10.9120577,17.4510067 11.5075941,18.009396 L18.5165984,24.5812081 C19.1121347,25.1395973 20.0741549,25.1395973 20.6696913,24.5812081 C21.2652276,24.0228188 21.2652276,23.1208054 20.6696913,22.5624161 L14.7448684,16.9928412 L20.6696913,11.4375839 C21.2652276,10.8791946 21.2499574,9.96286353 20.6696913,9.41879195 Z",
    id: "Left-Arrow",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/Arrowleft.97da2ff394e48b2cf1e3e4cabcc68abc.svg";
export { ForwardRef as ReactComponent };